import AjaxResolver from 'owd/module/ajax';
import Src from '../components/src';

export default class DefaultResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();

		$('.logo').each(function() {
			var html = $(this).html();
			$(this).html(html);
		});

		// $('.header').transition({
		// 	opacity: 1
		// }, 500, 'ease-out');

		
		$('html').addClass('loaded');
			setTimeout(function(){
				$('.preloader').transition({
					opacity: 0
				}, 200, 'ease-out', () => {
				$('.preloader').fadeOut();
				if($('.hero-video').length > 0) {
					$('.hero-video')[0].play();
				}
				if($('.casestudy-player-video').length > 0) {
					$('.casestudy-player-video')[0].play();
				}
				deferred.resolve();
			});
		},600);

		

		// $('.ajax-wrapper > *').transition({
		// 	opacity: 1
		// }, 500, 'ease-out', () => {
		// 	deferred.resolve();
		// });


		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();
		

		// $('.header').transition({
		// 	opacity: 0
		// }, 500, 'ease-out');
		$('.preloader').fadeIn();
		$('html').removeClass('loaded');

		$('.preloader').transition({
			opacity: 1
		}, 200, 'ease-out' );

		$('.nav--main').transition({
			opacity: 0
		}, 300, 'ease-out', () => {
			$('.header').transition({
				transform: 'translateY(-80%)',
				opacity: 0
			}, 300, 'ease-out', () => {
				this.app.dom.$window.scrollTop(0);
				deferred.resolve();
			});
		});

		// $('.ajax-wrapper > *').transition({
		// 	opacity: 0
		// }, 250, 'ease-out', () => {
		// 	this.app.dom.$window.scrollTop(0);
		// 	deferred.resolve();
		// });


		return deferred.promise();
	}
	

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		const $old = $('.ajax-wrapper');
		const $oldHeader = $('.header');
		const bodyClass = $loadedContent.find('.overall').data('body-class');
		const bodyTheme = $loadedContent.find('.overall').data('theme');

		// $loadedContent.find('.ajax-wrapper > *, .header').css({
		// 	opacity: 0
		// });


		if (this.preventUpdateBodyClass !== true) {
			$('body').attr('class', bodyClass);
			$('body').attr('data-theme', bodyTheme);
		}

		const $new = $loadedContent.find('.ajax-wrapper');
		const $newHeader = $loadedContent.find('.header');

		$old.after($new);
		$oldHeader.after($newHeader);
		$old.remove();
		$oldHeader.remove();

		deferred.resolve($old, $oldHeader, $new, $newHeader);

		return deferred.promise();
	}
}
